import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

const ClientsReview = () => {
  const reviews = [
    {
      name: "Joseph Frodsham",
      description:
        "All my creditor calls stopped after I got started in the program. With around $96,600 spread across 19 different credit cards I was getting what seemed like 100 calls a day after not being able to make the minimum payments for a couple months.  I was paying $3,400 a month to make the minimums and even when making them my balances never went down. My new payment is $1,150 a month. I really should have started this program years ago instead of throwing all the money away month after month.  Affordable Debt Consolidation has been a great blessing to have been able to help me in the way that they did.",
      when: "2 years ago",
      showAllText: false,
      gLink: "https://g.page/r/CVX-zL7gqWfSEBM/review",
    },
    {
      name: "Ruthanne North",
      description:
        "The greedy credit card companies and banks deferred our payments for 2-3 months but then cut our credit limits and raised our rates after my wife and tried asking them for help due to reductions in income.  We managed to accumulate just over a hundred thousand of credit cards and installment loans that was keeping us broke every single month, but the reduction of income made making even the amounts due monthly impossible to pay. We are now most of the way through the Affordable Debt program which is costing us much less than half of what we had been paying before and the process has been very a good experience.  I am always kept informed of my progress and I really do like the fact that my customer service representative always knows exactly who my wife and I are and makes us feel like we are a friend instead a number getting tossed around from one customer service rep to another customer service rep. I would 100% trust this company and if you have a lot of debt just as we have because they are treating us right.",
      when: "5 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CVX-zL7gqWfSEBM/review",
    },
    {
      name: "Dick Byrne",
      description:
        "I want to give my great appreciation to Affordable Debt Consolidation for helping eliminate my credit cards. This program has been a Godsend for my nearly 150 thousand in credit card debt that I could no longer afford. I made a local appointment and your wonderful representative Craig Flanders understood my entire financial situation and recommend options that all cost much less than I was paying. Thank you for everything you have done for me!",
      when: "6 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CYGX939jR7WQEBM/review",
    },
    {
      name: "Peter Rodriguez",
      description:
        "There was a time I was in financial trouble a couple of years ago. On a monthly basis. I was having to transfer money 💴 from one account to another Just to make and meet. My Financial future was In distress. Until I came across Affordable Debt Consolidation. Jack and his staff took great care of me and my situation. Now I’m on the road to financial recovery  There is light at the end of the tunnel. I’m almost there. 😀😀😀",
      when: "4 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CYGX939jR7WQEBM/review",
    },
    {
      name: "Fanny Sigler",
      description:
        "Called and was offered a local appointment here in Austin and it was the best decision I ever made.  I was about to enroll with a debt consolidation company who isn't local called Freedom Debt after seeing a commercial on TV but I found out they have a terrible reputation after checking them out with the Better Business Bureau. I have to say there are some huge difference between what I was offered with the Affordable Debt Consolidation program and what the other company wanted me to sign up for.  The fees are about 1/3 less compare to the Freedom Debt so if you live anywhere near Austin or live in Texas give them a call. I'd rather give a Texas company my business away and I am darn sure glad I did!",
      when: "4 years ago",
      showAllText: false,
      gLink: "https://g.page/r/CQVYGttQdn6yEBM/review",
    },
    {
      name: "Jaime Peterson",
      description:
        "Every bank I tried to get a loan to consolidation to pay nearly $93,000 in high interest credit cards had denied my application. The reality is I knew I probably wouldn’t qualify and I needed more serious professional help if I was going to avoid bankruptcy. The Affordable Debt Management  program was the perfect alternative since I am now paying well under half of what I was paying making just the bare minimum monthly payments. Also it is only going to take me 4 years to be done paying the debts. If you have a lot of debt like me this might be your ticket out of it. A consolidation loan is only a bandaid if you are already struggling. Thank you!",
      when: "2 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CQVYGttQdn6yEBM/review",
    },
    {
      name: "John Cutts",
      description:
        "Thank you for helping me to straighten out my finances and get rid of my insane high interest debt that has been keeping me broke every month. Your representative who enrolled me was very informative about different options to eliminate my debt and the pros and cons with each one.  Other companies tried to push me into one program, but I was very impressed that you representative was able to provide several completely different types of debt management. I feel I made the best choice and am certainly saving a ton of money every single month. Affordable Debt Consolidation is very highly recommended by me and they deserve an A+ all the way.",
      when: "2 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CQs9AH7sGgsAEBM/review",
    },
    {
      name: "David Myers",
      description:
        "If you want out of debt very fast this is your ticket. With no savings and barely anything set aside for retirement and I finally realized why....the money I had been throwing away for many years to credit card interest was essentially stealing my ability to save into my retirement!! I should of made better financial decisions but making the minimum payments was going to take me over 20 years to pay them off and that is just plain wrong of the credit card companies. After procrastinating I finally pulled the trigger and I got help with Affordable Debt Consolidation. I completed their program after 26 months and I’m quite sure I saved well over $100,000 or more in interest alone compare to if I just kept making them minimum payments. When I enrolled, I kept my program payments roughly the same monthly amount as I was directly paying the credit cards directly.  I was offered 3- and 4-year program options with much lower payments if needed, but I really just wanted to get this debt done and over with. They helped me to do exactly that and I am now saving an extra $1500 a for my badly need retirement investments which is only a few years off. Thank you!!!!",
      when: "3 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CQLDUc_87251EBM/review",
    },
    {
      name: "Jacob McAlroy",
      description:
        "I found Affordable Debt on the Better Business Bureau webpage and called to ask how they could help with my debt. My debt had accumulated to a little over a hundred grand, so I was going to make an appointment with a bankruptcy attorney if this didn't work out. I had already called one debt consolidation company and the savings was around a couple hundred a month, but I really needed a payment no more than half of my minimum payments due to decreased work hours. This is exactly what I got with the Affordable Debt Consolidation program. Your program is great, your company is great, and I have been recommending you to other since you have truly helped change my life for the better and I will always be grateful.",
      when: "4 months ago",
      showAllText: false,
      gLink: "https://g.page/r/CW5JL1rh3YPeEBM/review",
    },
  ];

  return (
    <section id="clientsReview" className="bg-custom-lightGray py-16">
      <div className="container px-4">
        <h2 className="text-[40px] text-[#475569] font-semibold text-center mb-6">
          Top Choice for Texans
        </h2>
        <Swiper
          pagination={{
            clickable: true,
            el: ".reviews-swiper-pagination",
            renderBullet: function (index, className) {
              return (
                '<span class="!h-2.5 !w-2.5 rounded-full m-2 top-0 right-0 mr-2 bg-custom-gray ' +
                className +
                '"></span>'
              );
            },
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          speed={500}
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            960: {
              slidesPerView: 2,
            },
            1364: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={28}
          loop
        >
          {reviews.map((review, index) => (
            <SwiperSlide className="mb-8" key={index}>
              <div
                className="bg-white rounded-3xl p-6 shadow-lg min-h-[300px]"
                key={index}
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="bg-[#475569] rounded-full w-10 h-10 flex items-center justify-center text-white">
                      {review.name.slice(0, 1)}
                    </div>
                    <div>
                      <h5 className="text-lg text-custom-primary font-semibold">
                        {review.name}
                      </h5>
                      <div className="flex items-center">
                        <img
                          src="/svgs/5-star.svg"
                          key={index}
                          width={98}
                          height={24}
                          alt="Star"
                        />
                        <p className="text-[#475569] text-md font-normal">
                          {review.when}
                        </p>
                      </div>
                    </div>
                  </div>
                  <img
                    src="/images/Google.webp"
                    width={40}
                    height={40}
                    alt="Google"
                  />
                </div>
                <p className="text-md font-medium text-custom-primary leading-6">
                  {review.description.slice(0, 300)}
                  {"... "}
                  <a
                    className="text-sky-700 font-medium"
                    href={review.gLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Read More
                  </a>
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="reviews-swiper-pagination flex justify-center" />
      </div>
    </section>
  );
};

export default ClientsReview;
